import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'BlogCategorySplit',
})(({ spacing, brandColors }) => ({
  divWrapper: {
    backgroundColor: brandColors.tintsOffWhite60,
  },
  grid: {
    rowGap: spacing(3),
  },
}));

export default useStyles;
